import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8 ">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
        <div className="bg-green-600 px-6 py-4">
          <h1 className="text-2xl font-bold text-white">Política de Privacidade - Dominus</h1>
          <p className="text-green-100 mt-1">Última atualização: 30 de abril de 2025</p>
        </div>

        <div className="p-6 space-y-10">
        <section className="mb-12">
            <div className="flex items-center mb-6 pb-2 border-b border-gray-200">
              <span className="text-2xl mr-2">📄</span>
              <h2 className="text-xl font-bold text-gray-800">1. POLÍTICA DE PRIVACIDADE (LGPD)</h2>
            </div>
            
            <p className="mb-4 text-gray-700">
              A Dominus Comércio de Eletrônicos Ltda. valoriza a privacidade dos seus usuários e garante o tratamento adequado e seguro dos dados pessoais, conforme a Lei Geral de Proteção de Dados Pessoais (LGPD - Lei nº 13.709/2018).
            </p>
            
            <div className="space-y-8">
              {/* 1.1 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.1. Quem somos</h3>
                <ul className="pl-5 list-disc text-gray-700 space-y-1">
                  <li>Razão Social: Dominus Comércio de Eletrônicos Ltda.</li>
                  <li>CNPJ: [inserir CNPJ]</li>
                  <li>Endereço: [inserir endereço completo]</li>
                  <li>E-mail para contato sobre privacidade: privacidade@dominus.com.br</li>
                </ul>
              </div>
              
              {/* 1.2 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.2. Quais dados coletamos</h3>
                <p className="text-gray-700 font-medium mb-1">Dados pessoais:</p>
                <p className="text-gray-700 mb-2">nome, CPF/CNPJ, e-mail, telefone, endereço completo.</p>
                
                <p className="text-gray-700 font-medium mb-1">Dados de pagamento:</p>
                <p className="text-gray-700 mb-2">informações para processar transações (não armazenamos dados sensíveis de cartão).</p>
                
                <p className="text-gray-700 font-medium mb-1">Dados de navegação:</p>
                <p className="text-gray-700">IP, geolocalização, páginas acessadas, cookies e identificadores de dispositivo.</p>
              </div>
              
              {/* 1.3 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.3. Como usamos seus dados</h3>
                <ul className="pl-5 list-disc text-gray-700 space-y-1">
                  <li>Processamento de pedidos e entregas;</li>
                  <li>Emissão de notas fiscais;</li>
                  <li>Atendimento ao cliente;</li>
                  <li>Envio de ofertas e comunicações (com seu consentimento);</li>
                  <li>Análise de uso e comportamento no site para melhorias.</li>
                </ul>
              </div>
              
              {/* 1.4 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.4. Com quem compartilhamos</h3>
                <p className="text-gray-700 mb-2">Seus dados podem ser compartilhados com:</p>
                <ul className="pl-5 list-disc text-gray-700 space-y-1 mb-2">
                  <li>Operadoras de pagamento;</li>
                  <li>Empresas de logística;</li>
                  <li>Plataformas de análise e marketing;</li>
                  <li>Órgãos públicos, mediante obrigação legal.</li>
                </ul>
                <p className="text-gray-700">Todos os terceiros contratados seguem regras de confidencialidade e segurança.</p>
              </div>
              
              {/* 1.5 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.5. Seus direitos</h3>
                <p className="text-gray-700 mb-2">Você pode, a qualquer momento:</p>
                <ul className="pl-5 list-disc text-gray-700 space-y-1 mb-2">
                  <li>Confirmar se tratamos seus dados;</li>
                  <li>Acessar, corrigir ou atualizar seus dados;</li>
                  <li>Solicitar a exclusão ou anonimização;</li>
                  <li>Solicitar portabilidade dos dados;</li>
                  <li>Revogar consentimentos.</li>
                </ul>
                <p className="text-gray-700">Envie sua solicitação para: privacidade@dominus.com.br</p>
              </div>
              
              {/* 1.6 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.6. Segurança</h3>
                <p className="text-gray-700">
                  Adotamos medidas de segurança como criptografia, controle de acesso e sistemas de proteção contra invasões para garantir a integridade dos seus dados.
                </p>
              </div>
              
              {/* 1.7 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.7. Retenção</h3>
                <p className="text-gray-700">
                  Seus dados são mantidos apenas pelo tempo necessário para cumprir as finalidades descritas ou exigências legais.
                </p>
              </div>
              
              {/* 1.8 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.8. Alterações nesta política</h3>
                <p className="text-gray-700">
                  Reservamo-nos o direito de modificar esta política a qualquer momento. Notificações serão feitas em nosso site em caso de mudanças significativas.
                </p>
              </div>
            </div>
          </section>
        </div>

        <div className="mt-8 px-6 pb-6">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
